<template>
    <div class="voucher-row">
        <!--日付/曜日-->
        <div class="date-row">
            <div class="d-inline-block text-center">
                {{ dateUtils.formatDateDD(voucher.transaction_date) }}
                <div class="day-of-week">
                    {{ dateUtils.getDay(voucher.transaction_date) }}
                </div>
            </div>
        </div>

        <!-- アイコン/証憑No -->
        <div class="icon-row">
            <div class="icon-style">
                <span class="icon-label" :class="{ 'ex-lb-in': !utils.getIconColor(voucher)}">
                    {{ utils.getIconToVoucherRow(voucher, isLocalIncome, isExchange) }}
                </span>
            </div>
            <div class="no-style">
                #<div class="txt-overflow">{{ voucher.voucher_number }}</div>
            </div>
        </div>

        <!--両替情報-->
        <div class="exchange-row" v-if="isExchange">
            <div>{{ utils.formatExchangeTitle(voucher) }}</div>
            <div class="exchange-style">
                <div>両替後:</div>
                <div>{{ utils.formatAfterPrice(voucher) }}</div>
            </div>
        </div>
        <!-- 用途/取引先 -->
        <div class="use-row" v-else>
            <div class="voucher-use txt-overflow">{{ utils.formatUse(voucher) }}</div>
            <div class="voucher-account txt-overflow">{{ utils.formatAccountName(voucher.account_name) }}</div>
        </div>

        <!-- 金額-->
        <div class="row-amount" :class="{ 'ex-am-in': isExchange}">
            <div class="row-tax-icon" v-show="isCarringCashs(voucher.voucher_type_id)">
                <div class="icon-tax" v-show="isShowIconTaxRate(voucher.tax_rate)"
                :class="{ 'ex-bg-skyblue': voucher.tax_rate == constants.VoucherTaxRate.Eight.id, 'ex-bg-blue': voucher.tax_rate == constants.VoucherTaxRate.Other.id}">
                    {{ taxRate }}
                </div>
                <div class="icon-dutyfree" :class="{ 'icon-opac': !voucher.tax_exempt}">免</div>
            </div>
            <div class="label-amount">
                {{ utils.formatPriceToVoucherRow(voucher, isExchange) }}
            </div>
        </div>

        <!-- ファイル有無-->
        <div class="static-img">
            <i class="icon-picture" v-if="voucher.has_file"></i>
        </div>
    </div>
</template>
<script>
import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';
import { Constants } from "@/helpers/constants";

export default {
    name: "CommonVoucherRow",
    props: {
        voucher: {},
        screenType: "",
        isExchange: false,
    },
    components: {},
    data() {
        const isLocalIncome = this.screenType == Constants.LocalIncomeScreenType;
        // const isExchange = this.screenType == Constants.ExchangeScreenType;
        return {
            utils: Utils,
            dateUtils: DateUtils,
            isLocalIncome: isLocalIncome,
            taxRate: "",
            constants: Constants,
        };
    },
    methods: {
        isCarringCashs (voucherTypeId) {
            const existIds = [Constants.VoucherType.no_voucher.id, Constants.VoucherType.receipt_carry_cash.id];
            return existIds.includes(voucherTypeId);
        },
        isShowIconTaxRate (tax_rate) {
            if (tax_rate == Constants.VoucherTaxRate.Eight.id) {
                this.taxRate = Constants.VoucherTaxRate.Eight.icon;
                return true;
            };

            if (tax_rate == Constants.VoucherTaxRate.Other.id) {
                this.taxRate = Constants.VoucherTaxRate.Other.icon;
                return true;
            };

            if (tax_rate == Constants.VoucherTaxRate.Free.id) {
                this.taxRate = Constants.VoucherTaxRate.Free.icon;
                return true;
            };

            return false;
        }
    },
};
</script>




// WEBPACK FOOTER //
// src/views/components/common/VoucherRow.vue